import { Project } from '../types';

const project: Project = {
  slug: 'baja-link-resort',
  accessPin: '8452',
  qrTickets: ['Q1Z9M7'],
  info: {
    id: 8,
    title: 'Baja Link Resort',
    category: {
      'en-US': 'Hospitality',
      'es-MX': 'Hospitalidad',
    },
    year: 2023,
    location: 'Loreto, Baja California Sur',
    floor: '2 floors',
    building: '10,000aZA-',
    cover: '/images/Cover8.webp',
    description: {
      'en-US':
        'Baja Link Resort is a conceptual design for a boutique coastal retreat, blending Mexican vernacular architecture with contemporary elegance. The masterplan includes open-air lounges, a rustic-chic bar, reception spaces, and private villas surrounded by lush vegetation. Local materials such as stone, stucco, woven fibers, and wood dominate the palette, offering a tactile and inviting environment. Architectural arches, pergolas, and artisan lighting reflect a relaxed luxury ideal for tropical destinations. The design prioritizes natural ventilation, indoor-outdoor connection, and sensory comfort for a holistic guest experience.',
      'es-MX':
        'Baja Link Resort es un diseno conceptual para un refugio costero boutique que combina arquitectura vernacula mexicana con elegancia contemporanea. El plan maestro incluye lounges al aire libre, un bar rustico-chic, areas de recepcion y villas privadas rodeadas de vegetacion. Materiales locales como piedra, estuco, fibras tejidas y madera dominan la paleta, creando un ambiente tactil y acogedor. Arcos, pergolas e iluminacion artesanal reflejan un lujo relajado ideal para destinos tropicales. El diseno prioriza la ventilacion natural, la conexion interior-exterior y el confort sensorial para una experiencia integral.',
    },
  },
  assets: {
    images: [
      { file: '8.1', ext: 'webp' },
      { file: '8.2', ext: 'webp' },
      { file: '8.3', ext: 'webp' },
      { file: '8.4', ext: 'webp' },
      { file: '8.5', ext: 'webp' },
      { file: '8.6', ext: 'webp' },
      { file: '8.7', ext: 'webp' },
      { file: '8.8', ext: 'webp' },
    ],
    videos: [],
    panos: [],
  },
};

export default project;
